import React from 'react';
import { BadgeCheckIcon, FileCheck2Icon, GiftIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-[#09281d] px-5 py-20" data-id="element-82" data-mp="4xclkwxcokc2">
      <div className="mx-auto max-w-3xl border-t-8 border-emerald-400 bg-white p-8 text-center shadow-2xl sm:p-14" data-id="element-83" data-mp="9u37i0vu6a5e">
        <p className="inline-flex items-center gap-2 bg-emerald-500 px-4 py-2 text-xs font-bold uppercase tracking-widest text-white" data-id="element-84" data-mp="eu8uh3r5v8h5">
          <BadgeCheckIcon className="h-4 w-4" data-id="element-85" data-mp="jqpt4rvzl58h" /> Zero risk · 100% protected
        </p>
        <ShieldCheckIcon className="mx-auto mt-7 h-20 w-20 text-emerald-700" strokeWidth={1.4} data-id="element-86" data-mp="ns1ayb8mcm64" />
        <h2 className="mt-6 font-display text-5xl font-bold uppercase leading-none text-[#09281d] sm:text-6xl" data-id="element-87" data-mp="xjxjyhc8twp4">
          7-day <span className="text-emerald-700" data-id="element-88" data-mp="12jjxyszwbgyz">guarantee</span>
        </h2>
        <p className="mx-auto mt-6 max-w-lg text-lg font-medium text-slate-600" data-id="element-89" data-mp="17i4og0pcima8">
          Open everything. Use the material. Put it to the test.
        </p>
        <p className="mt-5 text-2xl font-bold leading-tight text-[#09281d]" data-id="element-90" data-mp="25ti4sg7ruiyf">
          If P.E. READY 360 doesn’t transform the way you plan and run your PE
          lessons,{' '}
          <span className="text-emerald-700" data-id="element-91" data-mp="1vuslqk452sgl">
            we’ll refund every cent — no questions asked.
          </span>
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-x-5 gap-y-3 text-xs font-bold text-[#09281d]" data-id="element-92" data-mp="1rtyv3izbazk0">
          <span className="flex items-center gap-1.5" data-id="element-93" data-mp="2okiyopu1bob4">
            <ZapIcon className="h-4 w-4 text-emerald-700" data-id="element-94" data-mp="2jkd6n8jurzsi" /> Instant refund
          </span>
          <span className="flex items-center gap-1.5" data-id="element-95" data-mp="2ertr461luul2">
            <FileCheck2Icon className="h-4 w-4 text-emerald-700" data-id="element-96" data-mp="2eq8wkgfajbn7" /> No forms to
            fill
          </span>
          <span className="flex items-center gap-1.5" data-id="element-97" data-mp="378we5lv2w8jj">
            <GiftIcon className="h-4 w-4 text-emerald-700" data-id="element-98" data-mp="37ah8pbhe7rhe" /> Keep the bonuses
          </span>
        </div>
        <p className="mt-6 inline-block border border-emerald-500/40 bg-emerald-50 px-4 py-2 text-xs font-bold uppercase tracking-widest text-emerald-800" data-id="element-99" data-mp="32gwiw6pye3ta">
          Refund rate below 1%
        </p>
      </div>
    </section>;
}